import { io } from "socket.io-client";
import { store } from "../store/store.js";

const serverPath = "https://mitserver.app:9005/";
const version = "V2.1";

const token = localStorage.getItem("token");
const user = JSON.parse(localStorage.getItem("user"));
const query = { version: version };

if (user != null) {
	query.userId = user.id;
}
if (token != null) {
	query.token = token;
}

const socket = io(serverPath, {
	transports: ["websocket"],
	reconnection: true,
	reconnectionAttempts: 5,
	reconnectionDelay: 2000,
	query: query,
});

const connectionStatus = document.getElementById("socketAPI");

socket.on("connect", () => {
	connectionStatus.style.backgroundColor = "green";
});

socket.on("disconnect", (reason) => {
	connectionStatus.style.backgroundColor = "red";
});

socket.on("close", (reason) => {
	connectionStatus.style.backgroundColor = "red";
});

socket.on("error", (error) => {
	connectionStatus.style.backgroundColor = "red";
	showReconnectPopup();
	console.log("ERROR", error);
});

const isInWebView = (() => {
	const ua = navigator.userAgent || navigator.vendor || window.opera;
	return /iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
})();

document.addEventListener("visibilitychange", () => {
	if (document.visibilityState === "visible") {
		const selectedAccount = JSON.parse(localStorage.getItem("selectedAccount"));
		const symbolInfo = JSON.parse(localStorage.getItem("symbolInfo"));
		const token = localStorage.getItem("token");

		if (symbolInfo && selectedAccount) {
			let allPos = {
				symbol: symbolInfo.symbol,
				userId: selectedAccount.userId,
				account: selectedAccount.account,
			};
			socket.emit("allLines", allPos);
		}

		if (isInWebView) {
			try {
				const tvWidget = store.getState().tvWidget;
				if (!tvWidget || !tvWidget.activeChart) return;

				const chart = tvWidget.activeChart();
				const currentSymbol = chart.symbol();

				if (window.Datafeed?.resetCache) {
					window.Datafeed.resetCache();
					console.log("🧹 Cache reseteado");
				}

				chart.resetData();

				setTimeout(() => {
					chart.setSymbol(currentSymbol, () => {
						console.log("✅ Símbolo recargado");

						if (window.rechargeChart) {
							setTimeout(() => {
								window.rechargeChart();
							}, 300);
						}
					});
				}, 300);
			} catch (err) {
				console.error("❌ Error al refrescar el gráfico:", err);
			}
		} else {
			if (token) {
				window.checkingDerivConnection();
			}
		}
	}
});

export default socket;
